module.exports = __webpack_public_path__ + "img/in-progress-semipublic.4f0aa883.svg";